import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

/** Protects routes that require a signed-in user (e.g. /account/**). Starts
 * (or joins) the silent-refresh bootstrap before deciding, so a page refresh
 * doesn't bounce a still-loading session to /login. */
export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.bootstrap().pipe(
    take(1),
    map(() =>
      authService.isAuthenticated()
        ? true
        : router.createUrlTree(['/login'], {
            queryParams: { returnUrl: state.url },
          }),
    ),
  );
};
